import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Client } from '../models/client.model';
import { HttpService } from '../services/http.service';

@Injectable({
    providedIn: 'root',
})
export class ConfiguratorService {
    private httpService = inject(HttpService);

    clients$ = new BehaviorSubject<Client[] | false>(false);

    private subscription = new Subscription();

    dispatch(numberOfClients = 2): void {
        this.subscription.add(
            this.httpService
                .getClients(numberOfClients)
                .pipe(tap((clients) => this.clients$.next(clients)))
                .subscribe(),
        );
    }

    destroy(): void {
        this.subscription.unsubscribe();
    }
}
